import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'arrowLeft',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-arrow-left wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M13.436 5.263a.506.506 0 0 0-.003-.71l-.7-.701a.495.495 0 0 0-.71-.003l-7.779 7.777a.5.5 0 0 0-.144.352.48.48 0 0 0 .144.356l7.778 7.778a.506.506 0 0 0 .71-.003l.701-.7a.495.495 0 0 0 .003-.711l-5.702-5.703H19.36c.273 0 .5-.226.5-.505v-.99a.495.495 0 0 0-.5-.505H7.704z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-arrow-left.svg',
    category: 'Core',
    tags: ['back', 'navigation', 'ui'],
};
export default icon;
